'use client';

import { createContext, useContext, useEffect, useState } from 'react';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');
  const [dir, setDir] = useState('ltr');

  useEffect(() => {
    const saved = localStorage.getItem('uss_language');
    const lang = saved || 'en';
    setLanguage(lang);
    setDir(lang === 'ar' ? 'rtl' : 'ltr');
  }, []);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    setDir(lang === 'ar' ? 'rtl' : 'ltr');
    localStorage.setItem('uss_language', lang);
  };

  return (
    <LanguageContext.Provider data-component-id="src/components/common/LanguageProvider.jsx:25:4" data-component-path="src/components/common/LanguageProvider.jsx" data-component-line="25" data-component-end-line="27" data-component-file="LanguageProvider.jsx" data-component-name="LanguageContext.Provider" data-component-content="%7B%22elementName%22%3A%22LanguageContext.Provider%22%7D" value={{ language, dir, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
